import Agent from "core/services/api";
import { Result } from "core/models";

/**
 * get persistentValue for user by key
 * @param accessToken   Session access token
 * @param key     The persistentValue key
 *
 */

export const get = async (
    accessToken: string,
    key: string,
): Promise<Result<string, string>> => {
    try {
        const headers = new Headers();
        headers.append("Authorization", accessToken);

        const request = {
            category: "frontend",
            key,
        };
        const result = await Agent.post<string>(
            "/persistentvalue/get/v1",
            request,
            headers,
            "site",
        );

        const { resultObject } = result;

        if (!resultObject) {
            throw Error("Unable to get persistentValue or value doesn't exist");
        }

        return {
            value: resultObject,
            error: undefined,
        };
    } catch (err) {
        return {
            value: undefined,
            error: (err as Error).message,
        };
    }
};

/**
 * set persistentValue for user by key
 * @param accessToken   Session access token
 * @param key     The persistentValue key
 * @param value     The persistentValue value
 *
 */

export const set = async (
    accessToken: string,
    key: string,
    value: boolean | string,
): Promise<Result<string, string>> => {
    try {
        const headers = new Headers();
        headers.append("Authorization", accessToken);

        const request = { category: "frontend", key, value };
        const result = await Agent.post<string>(
            "/persistentvalue/set/v1",
            request,
            headers,
            "site",
        );

        const { resultObject } = result;

        if (!resultObject) {
            throw Error("Unable to get persistentValue");
        }

        return {
            value: resultObject,
            error: undefined,
        };
    } catch (err) {
        return {
            value: undefined,
            error: "Unable to get persistentValue",
        };
    }
};
